(() => {
  // app/scripts/common/function/scaleHeightAnimation.js
  function scaleHeightAnimation(element, options) {
    const { callback = null, memorize = false, duration = 400 } = options || {};
    let { lastScaleHeight = 0, scrollHeight: newScaleHeight } = element;
    if (!memorize) {
      lastScaleHeight = 0;
    }
    const anim = element.animate({
      height: [`${lastScaleHeight}px`, `${newScaleHeight}px`]
    }, {
      duration,
      easing: "cubic-bezier(0.645, 0.045, 0.355, 1)"
    });
    anim.onfinish = () => {
      element.lastScaleHeight = newScaleHeight;
      callback?.();
    };
  }

  // app/scripts/blog-component.js
  var BlogComponent = class extends HTMLElement {
    constructor() {
      super();
      this.resultWrapper = null;
      this.processedCards = /* @__PURE__ */ new Set();
      this.container = this.parentNode;
    }
    connectedCallback() {
      this.init();
    }
    init() {
      const scriptTag = this.querySelector('script[type="application/json"]');
      if (!scriptTag) {
        console.error("Blog Component: No JSON script tag found");
        return;
      }
      let urlsData;
      try {
        urlsData = JSON.parse(scriptTag.textContent);
      } catch (error) {
        console.error("Blog Component: Error parsing JSON data", error);
        return;
      }
      const urls = Array.isArray(urlsData) ? urlsData : urlsData.urls || [];
      if (urls.length === 0) {
        console.warn("Blog Component: No URLs found in data");
        return;
      }
      this.resultWrapper = this.querySelector(".jsResultWrapper");
      if (!this.resultWrapper) {
        console.error("Blog Component: .jsResultWrapper not found");
        return;
      }
      this.fetchAndMergeBlogs(urls);
    }
    async fetchAndMergeBlogs(urls) {
      try {
        const fetchPromises = urls.map((url) => this.fetchBlogSection(url));
        const results = await Promise.allSettled(fetchPromises);
        const blogCards = [];
        results.forEach((result, index) => {
          if (result.status === "fulfilled" && result.value) {
            const cards = this.extractBlogCards(result.value);
            blogCards.push(...cards);
          } else {
            console.warn(`Blog Component: Failed to fetch ${urls[index]}`, result.reason);
          }
        });
        const uniqueCards = this.removeDuplicateCards(blogCards);
        this.appendCardsToWrapper(uniqueCards);
      } catch (error) {
        console.error("Blog Component: Error fetching blogs", error);
      }
      if (this.resultWrapper.childElementCount > 0) {
        this.initSlider();
      } else {
        this.classList.add("no-results");
      }
      scaleHeightAnimation(this.container);
    }
    initSlider() {
      this.querySelector(".section-featured-blog").classList.remove("none");
      const slider = this.querySelector("slider-component");
      slider?.load?.();
    }
    async fetchBlogSection(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.text();
      } catch (error) {
        console.error(`Blog Component: Error fetching ${url}`, error);
        throw error;
      }
    }
    extractBlogCards(htmlContent) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      const shopifySection = tempDiv.querySelector(".shopify-section");
      if (!shopifySection) {
        console.warn("Blog Component: No .shopify-section found in response");
        return [];
      }
      let cards = Array.from(shopifySection.children);
      return Array.from(cards);
    }
    removeDuplicateCards(cards) {
      const uniqueCards = [];
      cards.forEach((card) => {
        const cardId = this.getCardIdentifier(card);
        if (!this.processedCards.has(cardId)) {
          this.processedCards.add(cardId);
          uniqueCards.push(card.cloneNode(true));
        }
      });
      return uniqueCards;
    }
    getCardIdentifier(card) {
      const titleElement = card.querySelector("h1, h2, h3, h4, h5, h6, .title, .blog-title, .article-title");
      const linkElement = card.querySelector("a[href]");
      const imageElement = card.querySelector("img[src]");
      if (titleElement && titleElement.textContent.trim()) {
        return titleElement.textContent.trim();
      }
      if (linkElement && linkElement.getAttribute("href")) {
        return linkElement.getAttribute("href");
      }
      if (imageElement && imageElement.getAttribute("src")) {
        return imageElement.getAttribute("src");
      }
      return this.hashCode(card.innerHTML);
    }
    hashCode(str) {
      let hash = 0;
      if (str.length === 0)
        return hash;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return hash.toString();
    }
    appendCardsToWrapper(cards) {
      if (!this.resultWrapper || cards.length === 0)
        return;
      const fragment = document.createDocumentFragment();
      cards.forEach((card) => {
        fragment.appendChild(card);
      });
      this.resultWrapper.appendChild(fragment);
    }
    // Method to manually refresh the component
    refresh() {
      this.processedCards.clear();
      if (this.resultWrapper) {
        this.resultWrapper.innerHTML = "";
      }
      this.init();
    }
  };
  customElements.define("blog-component", BlogComponent);
})();
